// extracted by mini-css-extract-plugin
export default {"main":"PanelContainer_main__TZ2nB"};